import { render, staticRenderFns } from "./ModalSuccessChangeColdStorageFee.vue?vue&type=template&id=677dd002&"
import script from "./ModalSuccessChangeColdStorageFee.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessChangeColdStorageFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports